import cogoToast from 'cogo-toast';

const showToast = (message) => {
    cogoToast.success(message, { hideAfter: 1.5 });
}

export {
    showToast,
}